import { Link, useLocation } from "react-router-dom"

export default function NavItem({ name, href, icon: Icon }) {
  const location = useLocation()
  const isActive = location.pathname === href

  return (
    <li>
      <Link
        to={href}
        className={`flex items-center px-3 py-2 rounded-md text-sm font-medium transition-colors duration-200 ${
          isActive
            ? "bg-blue-50 text-blue-600 dark:bg-blue-900/30 dark:text-blue-400"
            : "text-gray-700 dark:text-gray-200 hover:bg-gray-100 dark:hover:bg-gray-700"
        }`}
      >
        <Icon className="mr-3 h-5 w-5" />
        {name}
      </Link>
    </li>
  )
} 